<template>
  <nav
    id="navbarBlur"
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    :class="[isRTL ? 'top-1 position-sticky z-index-sticky' : '']"
    v-bind="$attrs"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :text-white="textWhite" />
      <div
        class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none"
        :class="isRTL ? 'me-3' : ''"
      >
        <a href="#" class="p-0 nav-link text-body" @click.prevent="minNav">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line" :class="textWhite ? 'bg-white' : ''"></i>
            <i class="sidenav-toggler-line" :class="textWhite ? 'bg-white' : ''"></i>
            <i class="sidenav-toggler-line" :class="textWhite ? 'bg-white' : ''"></i>
          </div>
        </a>
      </div>
      <div
        id="navbar"
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="$store.state.isRTL ? 'px-0' : 'me-sm-4'"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <!-- <div class="input-group z-index-1">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control"
              :placeholder="
                $store.state.isRTL ? 'أكتب هنا...' : 'Type here...'
              "
            />
          </div>-->
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item dropdown d-flex align-items-center">
            <vsud-avatar
              :img="[user.photo ? user.photo : imgDefault]"
              class="text-success text-gradient"
              alt="avatar image"
              border-radius="lg"
              v-if="user"
            />
          </li>
          <li class="px-3 nav-link d-flex align-items-center">
            <div class="position-relative ml-2 span">
              <a
                id="drownoutlogOut"
                href="#"
                class="cursor-pointer p-0 nav-link"
                :class="[
                textWhite ? textWhite : 'text-body',
                logOut ? 'show' : '',
              ]"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                @click="logOut = !logOut"
              >
                <span v-if="user" class="nav-link" :class="[
                textWhite ? textWhite : 'text-body']">
                  {{ " " + user.name + " " +
                  user.lastname }}
                </span>
              </a>

              <ul
                v-if="logOut"
                class="px-2 py-1 dropdown-menu dropdown-menu-end me-sm-n4 show"
                aria-labelledby="drownoutlogOut"
              >
                <li class="mb-1">
                  <a class="dropdown-item border-radius-md">
                    <div class="py-1 d-flex">
                      <div class="d-flex flex-column">
                        <h6 class="mb-1 text-sm font-weight-normal">
                          <div class="row">
                            <div class="col-2 ml-auto">
                              <font-awesome-icon :icon="['fass', 'right-to-bracket']" />
                            </div>
                            <div class="col-10 ml-auto">
                              <span class="font-weight-bold d-flex" @click="borrarToken">
                                Cerrar
                                sesión
                              </span>
                            </div>
                          </div>
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </li>




          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a id="iconNavbarSidenav" class="p-0 nav-link text-body" @click="toggleSidebar">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
          <li
            class="px-3 nav-item d-flex align-items-center"
            :class="$store.state.isRTL ? 'ps-2' : 'pe-2'" id="navbar-notification"
          >
            <a
              id="dropdownMenuButton"
              href="#"
              class="p-0 nav-link"
              :class="[textWhite ? textWhite : 'text-body',showMenu ? 'show' : '',]"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showMenu = !showMenu"
            >
              <i class="cursor-pointer fa fa-bell"></i>
              <span class="position-absolute top-10 start-100 translate-middle badge rounded-pill bg-danger">
                {{countNotifications}}+
                <span class="visually-hidden">unread messages</span>
              </span>
            </a>
            <!-- Lista de notificaciones -->
            <ul
              v-show="showMenu"
              class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4 show dropdownNotification"
              aria-labelledby="dropdownMenuButton"
            >
              <li class="mb-2" v-for="notification in listNotifications" :key="notification.id">
                <a class="dropdown-item border-radius-md" href="javascript:;" @click="viewMessage(notification)">
                  <div class="py-1 d-flex">
                    <div class="my-auto">
                      <img
                        :src="notification.user.photo ==null?photoDefault:notification.user.photo"
                        class="avatar avatar-sm me-3"
                        alt="user image"  
                      />
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span :class="notification.viewed==0?'font-weight-bold':'font-weight-normal'">{{notification.title}}</span> <br>
                        {{notification.user.name}} {{notification.user.lastname}}
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        {{notification.created_at}}
                      </p>
                    </div>
                    <span :class="notification.viewed==0?'notification-unread':'notification-read'" ></span>
                  </div>
                </a>
                
              </li>
              <hr>
              <li class="mb-2 text-center">
                <router-link class="dropdown-item border-radius-md" :to="{ name: 'Lista de notificaciones' }">                
                  Ver todas
                </router-link>
              </li>        


            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import VsudAvatar from "@/components/VsudAvatar.vue";
import imgDefault from "../../assets/img/user-default.png";
import { mapMutations, mapActions, mapState,mapGetters } from "vuex";
import axios from "axios";
import router from "@/router/index.js";
import notificationMixin from "@/mixins/notificationMixin";

export default {
  name: "Navbar",

  components: {
    Breadcrumbs,
    VsudAvatar,
    imgDefault,
  },
  mixins: [notificationMixin],
  props: {
    textWhite: {
      type: String,
      default: "",
    },
    minNav: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      path:'',
      showMenu: false,
      user: null,
      logOut: false,
      isHovered: false,
      photoDefault:"https://firebasestorage.googleapis.com/v0/b/bookapps-v2.appspot.com/o/bookapps%2Fnotifications%2Fuser-default.png?alt=media&token=9439fc20-8ac0-463f-a211-c3efc7c8c009"
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  created() {
    this.minNav;
    this.getNotifications();
  },
  methods: {
    async viewMessage(notification) {       
      await this.makeRoute(notification);
      this.markAsSeen(notification);
      this.$router.push({
        path: this.path,
        replace: true,
      });

    },
    async makeRoute(notification) {
      console.log("notification: ",notification);
      switch (notification.status_message) {
        case "published":
          this.path = `/mensajes/mensajes/${notification.message_id}`;
        break;
        case "pending":
          this.path = `/mensajes/mensajes-aprobar/${notification.message_id}`;
        break;
      }
    },
    markAsSeen(notification) {     
      if (notification.viewed == 0) {
        this.seenMessage(notification);
      }
    },
    async seenMessage(notification) {
      const user = JSON.parse(localStorage.getItem("user"));
      const dataSend = {
        message: notification.message.id,
        user: user.id,
        student: notification.participant.student_id,
        group: notification.participant.group_id,
      };
      const { status, data } = await axios.post(
        `${process.env.VUE_APP_API_BOOKAPP}messages/viewed`,
        dataSend,
        {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        }
      );

      if (status == 200) {
        this.SET_NOTIFICATION_MARK_AS_VIEWED(notification.message.id);
        this.SET_NOTIFICATIONS_COUNT(this.countNotifications - 1);
      } else {
        console.log("Hubo un error coonsultando los tipos de mensaje");
      }
    },
    async borrarToken() {
      this.$store.commit('setLoading',true);
      try {
        const { status, data } = await axios.get(
          `${process.env.VUE_APP_API_BOOKAPP}logout`,
          {
            headers: {
              Authorization: localStorage.getItem("token_bookapp"),
              conexion: localStorage.getItem("conexion"),
            },
          }
        );
        if (status == 200) {
          localStorage.removeItem("token_bookapp");
          localStorage.removeItem("conexion");
          localStorage.removeItem("token_manage");
          localStorage.removeItem("user");
          localStorage.removeItem("school");
          localStorage.removeItem("permissions");
          localStorage.removeItem("roles");
          location.reload();
        } 
        else if (status == 401) {
          localStorage.removeItem("token_bookapp");
          localStorage.removeItem("conexion");
          localStorage.removeItem("token_manage");
          localStorage.removeItem("user");
          localStorage.removeItem("school");
          localStorage.removeItem("permissions");
          localStorage.removeItem("roles");
          location.reload();
        } 
        else {
          console.log("error", data);
        }
      } catch (error) {
        console.log("error al cerrar session: ", error);
      }finally{
        this.$store.commit('setLoading',false);
      }
    },
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      // console.log("desde la funcion toggle");
      this.navbarMinimize();
    },
  },
};
</script>
<style scoped>
span.nav-link:hover {
  color: #f06c30;
}

.notification-unread {
  position: absolute;
  right: 15px;
  width: 10px;
  height: 10px;
  background-color: #1877F2; /* Azul de Facebook */
  border-radius: 50%;
}

.notification-read {
  position: absolute;
  right: 15px;
  width: 10px;
  height: 10px;
  border: 1px solid #1877F2; /* Azul de Facebook */
  background-color: white; /* Azul de Facebook */
  border-radius: 50%;
}
</style>